import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <h3>Agent Kolqo</h3>
        <div className="footer-links">
          <a href="mailto:contact@kolqo.com">📧 contact@kolqo.com</a>
          <span>|</span>
          <a href="#conditions">Conditions d'utilisation</a>
          <span>|</span>
          <a href="#confidentialite">Politique de confidentialité</a>
        </div>
        <p className="footer-copy">© 2026 Agent Kolqo. Tous droits réservés.</p>
      </div>
    </footer>
  );
}

export default Footer;